import { render } from "./home.vue?vue&type=template&id=0edd945a&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=0edd945a&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edd945a"]])

export default __exports__